/**
 * Satisfaction gauge, a semi-circular dial used to replace the star-rating
 * visual on the CSAT use-case card. Pure SVG, no dependencies.
 */
export default function CSATGauge({ value = 88, accent = "#8fd0ff", size = 180 }) {
    const clamped = Math.max(0, Math.min(100, value));
    // Sweep along a 180° arc. Circumference of a semi-circle of radius 70 = π*70.
    const R = 70;
    const CIRC = Math.PI * R;
    const filled = (clamped / 100) * CIRC;

    return (
        <svg
            width={size}
            height={size * 0.7}
            viewBox="0 0 200 130"
            role="img"
            aria-label={`Customer satisfaction score ${clamped} out of 100`}
            style={{ display: "block", overflow: "visible" }}
        >
            {/* base ring */}
            <path
                d="M20 110 A80 80 0 0 1 180 110"
                fill="none"
                stroke="#1e2632"
                strokeWidth="12"
                strokeLinecap="round"
            />
            {/* filled arc */}
            <path
                d="M20 110 A80 80 0 0 1 180 110"
                fill="none"
                stroke={accent}
                strokeWidth="12"
                strokeLinecap="round"
                strokeDasharray={`${filled} 999`}
                style={{
                    filter: `drop-shadow(0 0 10px ${accent}88)`,
                    transition: "stroke-dasharray .6s ease",
                }}
            />
            {/* tick marks */}
            {[0, 25, 50, 75, 100].map((tick) => {
                // angle: 180° at 0, 0° at 100 -> radians
                const a = Math.PI - (tick / 100) * Math.PI;
                const x1 = 100 + Math.cos(a) * 92;
                const y1 = 110 - Math.sin(a) * 92;
                const x2 = 100 + Math.cos(a) * 98;
                const y2 = 110 - Math.sin(a) * 98;
                return (
                    <line
                        key={tick}
                        x1={x1}
                        y1={y1}
                        x2={x2}
                        y2={y2}
                        stroke="#28323f"
                        strokeWidth="1.4"
                    />
                );
            })}
            {/* score number */}
            <text
                x="100"
                y="98"
                textAnchor="middle"
                fill="#fff"
                style={{
                    fontFamily: "'Bricolage Grotesque', sans-serif",
                    fontSize: "34px",
                    fontWeight: 700,
                }}
            >
                {clamped}
            </text>
            <text
                x="100"
                y="118"
                textAnchor="middle"
                fill="#8b929e"
                style={{
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: "9px",
                    letterSpacing: "0.14em",
                }}
            >
                CSAT SCORE
            </text>
        </svg>
    );
}
